module.exports = __webpack_public_path__ + "static/media/company-logo-4.c8bf10ce.png";